(() => {
  const STORAGE_KEY = 'ncs-favorites-v1';

  const escapeHTML = (value = '') =>
    String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');

  const readFavorites = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      console.warn('Unable to read favorites.', error);
      return [];
    }
  };

  const saveFavorites = (favorites) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.warn('Unable to save favorites.', error);
    }
  };

  const getProductFromButton = (button) => ({
    id: button.dataset.productId || '',
    handle: button.dataset.productHandle || '',
    url: button.dataset.productUrl || '',
    title: button.dataset.productTitle || '',
    image: button.dataset.productImage || '',
    secondImage: button.dataset.productSecondImage || '',
    price: button.dataset.productPrice || '',
    comparePrice: button.dataset.productComparePrice || '',
    freeShipping: button.dataset.productFreeShipping === 'true',
    discount: Number.parseInt(button.dataset.productDiscount || '0', 10),
    type: button.dataset.productType || ''
  });

  const isFavorite = (handle) =>
    readFavorites().some((item) => item.handle === handle);

  const syncButtons = () => {
    const favorites = readFavorites();

    document.querySelectorAll('[data-ncs-favorite]').forEach((button) => {
      const active = favorites.some(
        (item) => item.handle === button.dataset.productHandle
      );

      button.setAttribute('aria-pressed', String(active));

      const label = active
        ? button.dataset.labelRemove || 'Remove from favorites'
        : button.dataset.labelAdd || 'Add to favorites';

      button.setAttribute('aria-label', label);
      button.title = label;
    });

    document.querySelectorAll('[data-ncs-favorites-count]').forEach((node) => {
      node.textContent = String(favorites.length);
    });
  };

  const formatNcsMoney = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  const amount = (Number(cents) / 100).toFixed(2);

  const symbols = {
    USD: '$',
    CAD: '$',
    EUR: '€',
    GBP: '£'
  };

  const symbol = symbols[currency] || '';

  return `${symbol}${amount} ${currency}`.trim();
};

  const getViewOptionsLabel = () => {
  const language = (
    document.documentElement.lang ||
    window.Shopify?.locale ||
    'en'
  )
    .toLowerCase()
    .split('-')[0];

  const getFromPriceLabel = () => {
  const language = (
    document.documentElement.lang ||
    window.Shopify?.locale ||
    'en'
  )
    .toLowerCase()
    .split('-')[0];

  const labels = {
    en: 'From',
    es: 'Desde',
    fr: 'À partir de'
  };

  return labels[language] || labels.en;
};

  const labels = {
    en: 'View options',
    es: 'Ver opciones',
    fr: 'Voir les options'
  };

  return labels[language] || labels.en;
};

  const getLocalizedProduct = async (item) => {
  if (!item.handle) return item;

  try {
    const response = await fetch(
      `${window.Shopify.routes.root}products/${encodeURIComponent(item.handle)}.js`
    );

    if (!response.ok) {
      throw new Error(`Product request failed: ${response.status}`);
    }

    const product = await response.json();
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const firstVariant = variants[0];

    const variantPrices = variants
      .map((variant) => Number(variant.price))
      .filter((price) => Number.isFinite(price));

    const minimumPrice =
      variantPrices.length > 0
        ? Math.min(...variantPrices)
        : Number(firstVariant?.price || 0);

    const maximumPrice =
      variantPrices.length > 0
        ? Math.max(...variantPrices)
        : minimumPrice;

    const priceVaries = maximumPrice > minimumPrice;

    const localizedPrice = priceVaries
      ? `${getFromPriceLabel()} ${formatNcsMoney(minimumPrice)}`
      : formatNcsMoney(minimumPrice);

    return {
      ...item,
      id: product.id || item.id,
      handle: product.handle || item.handle,
      url: `${window.Shopify.routes.root}products/${product.handle}`,
      title: product.title || item.title,
      type: product.type || item.type,
      image: product.featured_image || item.image,
      secondImage: product.images?.[1] || item.secondImage,
      price: localizedPrice,
      priceVaries,
      comparePrice:
        firstVariant?.compare_at_price &&
        firstVariant.compare_at_price > firstVariant.price
          ? formatNcsMoney(firstVariant.compare_at_price)
          : ''
    };
  } catch (error) {
    console.warn(`Unable to localize product ${item.handle}.`, error);
    return item;
  }
};

  const favoriteCardHTML = (item) => {
    const freeShippingText =
  window.NCSFavoritesTranslations?.freeShipping || 'Free shipping';

const shippingBadge = item.freeShipping
  ? `<span class="ncs-product-card__badge ncs-product-card__badge--shipping">${freeShippingText}</span>`
  : '';

    const saleBadge =
      item.discount > 0
        ? `<span class="ncs-product-card__badge ncs-product-card__badge--sale">-${item.discount}%</span>`
        : '';

    const secondImage = item.secondImage
      ? `<img
          src="${escapeHTML(item.secondImage)}"
          alt="${escapeHTML(item.title)}"
          loading="lazy"
          class="ncs-product-card__image ncs-product-card__image--secondary"
        >`
      : '';

    const comparePrice = item.comparePrice
      ? `<del class="ncs-product-card__compare-price">${escapeHTML(item.comparePrice)}</del>`
      : '';

    const type = item.type
      ? `<p class="ncs-product-card__type">${escapeHTML(item.type)}</p>`
      : '';

    return `
      <article
        class="ncs-product-card"
        data-ncs-product-card
        data-product-id="${escapeHTML(item.id)}"
      >
        <div class="ncs-product-card__media">
          <a
            href="${escapeHTML(item.url)}"
            class="ncs-product-card__media-link"
            aria-label="${escapeHTML(item.title)}"
          >
            <img
              src="${escapeHTML(item.image)}"
              alt="${escapeHTML(item.title)}"
              loading="lazy"
              class="ncs-product-card__image ncs-product-card__image--primary"
            >
            ${secondImage}
            <span class="ncs-product-card__view-options">${getViewOptionsLabel()}</span>
          </a>

          <div class="ncs-product-card__badges">
            ${shippingBadge}
            ${saleBadge}
          </div>

          <button
            type="button"
            class="ncs-favorite-button"
            data-ncs-favorite
            data-product-id="${escapeHTML(item.id)}"
            data-product-handle="${escapeHTML(item.handle)}"
            data-product-url="${escapeHTML(item.url)}"
            data-label-add="Add ${escapeHTML(item.title)} to favorites"
            data-label-remove="Remove ${escapeHTML(item.title)} from favorites"
            aria-label="Remove ${escapeHTML(item.title)} from favorites"
            aria-pressed="true"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path>
            </svg>
          </button>
        </div>

        <div class="ncs-product-card__content">
          ${type}

          <h3 class="ncs-product-card__title">
            <a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a>
          </h3>

          <div class="ncs-product-card__price">
            <span class="ncs-product-card__current-price">
              ${escapeHTML(item.price)}
            </span>
            ${comparePrice}
          </div>
        </div>
      </article>
    `;
  };

 const renderFavoritesPage = async () => {
  const grid = document.querySelector('[data-ncs-favorites-grid]');
  const emptyState = document.querySelector('[data-ncs-favorites-empty]');

  if (!grid) return;

  const favorites = readFavorites();

  grid.hidden = favorites.length === 0;

  if (emptyState) {
    emptyState.hidden = favorites.length !== 0;
  }

  if (favorites.length === 0) {
    grid.innerHTML = '';
    syncButtons();
    return;
  }

  const localizedFavorites = await Promise.all(
    favorites.map(getLocalizedProduct)
  );

  grid.innerHTML = localizedFavorites.map(favoriteCardHTML).join('');

  syncButtons();
};

  const toggleFavorite = (button) => {
    const product = getProductFromButton(button);

    if (!product.handle) return;

    const favorites = readFavorites();
    const existingIndex = favorites.findIndex(
      (item) => item.handle === product.handle
    );

    if (existingIndex >= 0) {
      favorites.splice(existingIndex, 1);
    } else {
      favorites.unshift(product);
    }

    saveFavorites(favorites);
    syncButtons();
    renderFavoritesPage();

    document.dispatchEvent(
      new CustomEvent('ncs:favorites-updated', {
        detail: {
          favorites
        }
      })
    );
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ncs-favorite]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    toggleFavorite(button);
  });

  const initialize = () => {
    syncButtons();
    renderFavoritesPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();